export default "__VITE_ASSET__DDMZWJOe__"